export default "__VITE_ASSET__BiuUHFt7__"